export enum NotificationChannel {
  PUSH_NOTIFICATION = 'PushNotification',
  EMAIL = 'Email',
  SMS = 'Sms',
  WHATSAPP = 'WhatsApp',
}
